import {
  useGetMasterDistrict,
  useGetMasterProvince,
} from "hooks/useMasterData";
import styled from "@emotion/styled";
import { Button, Form, Input, Modal, Select, Spin, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  DeliveryPointData,
  MasterDistrictResponse,
  MasterProvinceResponse,
} from "services/interface";
import { useUpdateDeliveryPoint } from "hooks/useShipping";
import { useAppSelector } from "store";
import { useQueryClient } from "@tanstack/react-query";

type Props = {
  onClose: () => void;
  showParking: boolean;
  editData: DeliveryPointData | undefined;
};

const { Option } = Select;

const ModalEditDeliveryPoint = ({ onClose, showParking, editData }: Props) => {
  const [province, setProvince] = useState<MasterProvinceResponse>();
  const [district, setDistrict] = useState<MasterDistrictResponse>();

  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  const queryClient = useQueryClient();


  const profile = useAppSelector((state) => state.auth.profile);

  const { data: masterProviceData, isLoading: proviceLoading } =
    useGetMasterProvince();

  const { mutate, isPending } = useUpdateDeliveryPoint();
  

  useEffect(() => {
    if (masterProviceData) {
      setProvince(masterProviceData);
    }
  }, [masterProviceData]);

  const childrenProvince: React.ReactNode[] = [];
  province?.map((item) => {
    childrenProvince.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterDistrictData, isLoading: districtLoading } =
    useGetMasterDistrict(provinceId);

  useEffect(() => {
    if (masterDistrictData) {
      setDistrict(masterDistrictData);
    }
  }, [masterDistrictData]);

  const childrenDistrict: React.ReactNode[] = [];
  district?.map((item) => {
    childrenDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const [formModal] = Form.useForm();

  useEffect(() => {
    if (editData) {
      formModal.setFieldsValue({
        name: editData.delivery_point,
        province: editData.province_id,
        district: editData.district_id,
      });
      setProvinceId(editData.province_id);
      setDistrictId(editData.district_id);
    }
  }, [editData, formModal]);

  const onFinishModal = (values: any) => {
    console.log(values);
    mutate({
      id: editData?.id || "",
      name: values.name,
      district_id: values.district,
      province_id: values.province,
      factory_id:  profile?.user?.role?.ref_id || "",
    },
    {
      onSuccess: (res) => {
        if(res.status === 'success') {
          onClose();
          message.success("แก้ไขจุดส่งสินค้าสำเร็จ");
          formModal.resetFields();
          queryClient.refetchQueries({
            queryKey: ["deliveryPoint"],
            type: "all",
          });
        }else{
        
          message.error("แก้ไขจุดส่งสินค้าไม่สำเร็จ");
          onClose();
          formModal.resetFields();
        }
     
      },
      onError: () => {
        message.error("แก้ไขจุดส่งสินค้าไม่สำเร็จ");
        onClose();
        formModal.resetFields();
      },
    }
    )
  };

  return (
    <div>
      <Modal
        title="แก้ไขจุดส่งสินค้า"
        open={showParking}
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        // onOk={() => form.submit()}
        style={{ top: 20 }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              onClose();
              formModal.resetFields();
            }}
          >
            ยกเลิก
          </Button>,
          <Button
            disabled={isPending}
            key="submit"
            type="primary"
            onClick={() => formModal.submit()}
          >
            บันทึก
          </Button>,
        ]}
      >
        <WrapperAll>
          <Form form={formModal} onFinish={onFinishModal}>
            <Form.Item
              label="จังหวัด"
              className="form-transport"
              name="province"
              required
              rules={[
                {
                  required: true,
                  message: "กรุณาเลือกจังหวัด",
                },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                showSearch
                allowClear
                placeholder="จังหวัด"
                optionFilterProp="children"
                onChange={(value) => {
                  setProvinceId(value);
                  formModal.setFieldsValue({
                    district: undefined,
                  });
                }}
                notFoundContent={proviceLoading ? <Spin size="small" /> : null}
                loading={proviceLoading}
              >
                {childrenProvince}
              </Select>
            </Form.Item>
            <Form.Item
              label="อำเภอ"
              className="form-transport"
              name="district"
              required
              rules={
                [
                    {
                      required: false,
                      message: "กรุณาเลือกอำเภอ",
                    },
                ]
              }
            >
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="อำเภอ"
                optionFilterProp="children"
                onChange={(value) => {
                  setDistrictId(value);
                }}
                notFoundContent={districtLoading ? <Spin size="small" /> : null}
                loading={districtLoading}
                allowClear
              >
                {childrenDistrict}
              </Select>
            </Form.Item>
            <Form.Item
              labelAlign="left"
              label="ชื่อจุดจอด"
              name="name"
              required
              rules={[
                {
                  required: true,
                  message: "กรุณากรอกชื่อจุดจอด",
                },
              ]}
            >
              <Input placeholder="ชื่อจุดจอด" size="small" autoComplete="off" />
            </Form.Item>
          </Form>
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default ModalEditDeliveryPoint;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
